export const ON_ROW_INPUT_CHANGE = 'ON_ROW_INPUT_CHANGE';
export const onRowChange = (index, field, value) => ({
    type: ON_ROW_INPUT_CHANGE,
    index,
    field,
    value
})

export const ON_META_FIELD_CHANGE = 'ON_META_FIELD_CHANGE';
export const onMetaFieldChange = (field, value) => ({
    type: ON_META_FIELD_CHANGE,
    field,
    value
})

export const ON_REMOVE_FOCUS = 'ON_REMOVE_FOCUS';
export const onRemoveFocus = (index, field) => ({
    type: ON_REMOVE_FOCUS,
    index,
    field
})

export const ON_CLICK = 'ON_CLICK';
export const onClick = (id, value) => ({
    type: ON_CLICK,
    id,
    value
})

let rowId = 1; // table initially starts with rowId 0 existing

export const INSERT_PARTIAL = 'INSERT_PARTIAL';
export const insertPartial = (index, billNumber) => ({
    type: INSERT_PARTIAL,
    index,
    billNumber,
    rowId: rowId++
})

export const INSERT_ROW = 'INSERT_ROW';
export const insertRow = (index, billNumber) => ({
    type: INSERT_ROW,
    index,
    billNumber,
    rowId: rowId++
})

export const REMOVE_ROW = 'REMOVE_ROW';
export const removeRow = (index, billNumber) => ({
    type: REMOVE_ROW,
    index,
    billNumber
})

export const CLEAR_ALL_FIELDS = 'CLEAR_ALL_FIELDS';
export const clearAllFields = () => ({
    type: CLEAR_ALL_FIELDS
})
